<template>
    <div>
        <div class="row">
            <div class="col-lg-9 col-md-12 col-sm-12">
                <div class="block no-padding market-header">
                    <div class="block--header-image">
                        <img :src="market.banner"/>
                    </div>
                    <div class="block--content">
                        <div class="row">
                            <h4 class="col-10">{{market.name}}, <span>{{market.city}}</span></h4>
                            <div class="col-2 market-header-buttons">
                                <div>
                                    <i class="mdi mdi-pencil button--icon"></i>
                                    <i class="mdi mdi-favorite-outline"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="loading" v-if="loading">
                        <div class="spinner" style="top: 40%;"></div>
                    </div>
                </div>
            </div>

            <!--<div class="col-lg-1"></div>-->

            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="block opening-times">
                    <div class="block--content">
                        <div class="row">
                            <div class="col">
                                <h4>Openingstijden</h4>
                            </div>
                        </div>
                        <div class="times" style="flex: 1 1 auto;">
                            <div v-for="time in market.openingTimes" class="time">
                                <div class="row" style="margin-bottom: 0.8rem;">
                                    <div class="col-8 no-gutters"><strong>{{getDay(time.day)}}</strong></div>
                                    <div class="col-2 no-gutters edit" @click="editTime(time)"><i class="mdi mdi-pencil button--icon"></i></div>
                                    <div class="col-2 no-gutters delete" @click="confirmRemoveTime(time)"><i class="mdi mdi-delete button--icon"></i></div>
                                </div>
                                <div class="row">
                                    <div class="col-5">{{time.open}}</div>
                                    <div class="col-2" style="text-align: center;">tot</div>
                                    <div class="col-5" style="text-align: end;">{{time.close}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="buttons" style="width: 100%; margin-top: 2.4rem;">
                        <button class="button--cta" @click="$modal.show('add-time-modal', { market })" style="width: 100%;">Toevoegen</button>
                    </div>

                    <div class="loading" v-if="loading">
                        <div class="spinner" style="top: 40%;"></div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-lg-4 col-sm-12">
                test
            </div>
        </div>

        <remove-time-modal @confirm="removeTime"></remove-time-modal>
        <add-time-modal @save="createOpeningTime"></add-time-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import firebase from 'firebase';
    import RemoveTimeModal from './modals/RemoveTimeModal.vue';
    import AddTimeModal from './modals/AddTimeModal.vue';
    import {getDayLong, getDaysLong} from '@/utils';

    require("firebase/firestore");

    @Component
    export default class MarketPage extends Vue {

        market = {};

        loading = true;

        mounted() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.fetchMarket();
                } else {
                    // No user is signed in.
                    console.log(App.name, 'User is signed out');
                    this.$router.push('/auth');
                }
            });
        }

        fetchMarket() {
            firebase.firestore().collection('markets').doc(this.$route.params.key)
              .get()
              .then((snap) => {
                  console.log('Stand!', snap.data());

                  this.loading = false;
                  this.market = snap.data();
              }).catch((error) => {
                console.error('Error', error);
                this.loading = false;
            });
        }



        getDay(day) {
            return getDayLong(day);
        }

        getDays() {
            return getDaysLong();
        }

        /**
         * Save a new opening time for the selected market.
         */
        createOpeningTime(time) {
            var times = this.market.openingTimes;
            if (!times) {
                times = {};
            }
            console.log('CREATE', time, times);

            //Check if time doesn't already exists
            times[time.day] = time;

            firebase.firestore().collection('markets').doc(this.market.key).update({
                openingTimes: times
            }).then(() => {
                this.$modal.hide('add-time-modal');
                this.$notify('Nieuwe openingstijd is toegevoegd', 'success');

                this.fetchMarket();
            }).catch();
        }

        /**
         * Edit an existing openingstime
         */
        editTime(time) {
            this.$modal.show('add-time-modal', { time });
        }

        /**
         * Show a confirmation modal for deleting an openingstime
         * @param time
         */
        confirmRemoveTime(time) {
            this.$modal.show('remove-time-modal', { time });
        }

        /**
         * Delete an openingstime
         * @param time
         */
        removeTime(time) {
            var times = this.market.openingTimes;
            if (!times) {
                times = {};
            }

            delete times[time.day];

            firebase.firestore().collection('markets').doc(this.market.key).update({
                openingTimes: times
            }).then(() => {
                this.$modal.hide('remove-time-modal');
                this.$notify('Openingstijd voor ' + this.getDays()[time.day - 1] + ' verwijderd', 'success');

                this.fetchMarket();
            }).catch();
        }
    }

    Vue.component('market-page', MarketPage);
</script>

<style src="./market.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/market/MarketPage.vue